/**
 * LocalStorage key constants
 * Use these instead of hardcoded strings to prevent typos and enable easy refactoring
 */
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'auth_token'
} as const;
